export default {
  data: () => ({
    // Must be set by implementing component
    config: {},
  }),

  computed: {
    locale() {
      // Iubenda only accepts base language codes (e.g., 'en'), not locale codes (e.g., 'en-US')
      // Extract the base language from locale if it contains a hyphen
      const fullLocale = this.$i18n.locale
      return fullLocale.includes('-') ? fullLocale.split('-')[0] : fullLocale
    },
  },
}
